import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  private hubConnection!: signalR.HubConnection;

  startConnection(url: string) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(url?.replace('api/','')?.replace('API/','') +'serviceHub')
      .withAutomaticReconnect()
      .build();

    this.hubConnection.serverTimeoutInMilliseconds = 120000; // 2 minutos
    this.hubConnection.keepAliveIntervalInMilliseconds = 15000; // 15 segundos

    this.hubConnection
      .start()
      .catch(err => console.log('Error al iniciar SignalR: ', err));
  }

  addListener(event: string, callback:(data: any)=> void) {
    this.hubConnection.on(event, (data: any) => {
      callback(data);
    });
  }
}